import script from "./UiColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiColor.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiColor.vue?vue&type=style&index=0&id=57235bbb&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__